import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheckIcon, FactoryIcon, PackageIcon, FileTextIcon, ShoppingCartIcon, SettingsIcon, CogIcon, ShoppingBagIcon, ArrowRightIcon, FlaskConicalIcon, CpuIcon, BuildingIcon, SmartphoneIcon } from 'lucide-react';
function MenuItem({
  icon: Icon,
  label,
  to
}: {
  icon: ComponentType<{
    className?: string;
  }>;
  label: string;
  to: string;
}) {
  return <Link to={to} className="flex items-center gap-3 group/item" data-id="element-305">
      <div className="p-1.5 rounded-md bg-white/5 group-hover/item:bg-violet-electric/20 transition-colors" data-id="element-306">
        <Icon className="w-4 h-4 text-white/60 group-hover/item:text-violet-electric transition-colors" data-id="element-307" />
      </div>
      <span className="text-white/80 text-sm font-medium group-hover/item:text-white transition-colors" data-id="element-308">
        {label}
      </span>
    </Link>;
}
export function SolutionsMenu({
  onClose
}: {
  onClose?: () => void;
}) {
  return <div className="absolute top-full left-1/2 -translate-x-1/2 w-[1100px] pt-3 z-50" onClick={onClose} data-id="element-309">
      <div className="bg-[#0D0B2E]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden" data-id="element-310">
        <div className="grid grid-cols-12 divide-x divide-white/10" data-id="element-311">
          {/* Left Column: Intro */}
          <div className="col-span-3 p-6 bg-white/[0.02] flex flex-col justify-between" data-id="element-312">
            <div data-id="element-313">
              <h3 className="text-white font-semibold text-sm tracking-wide mb-3" data-id="element-314">
                All Solutions
              </h3>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-315">
                Operational modules built to work together. Adaptable to your
                company's workflows.
              </p>
            </div>
          </div>

          {/* By Module */}
          <div className="col-span-3 p-6" data-id="element-316">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-317">
              By Module
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-318">
              <MenuItem icon={ShoppingCartIcon} label="Purchasing" to="/solutions/purchasing" data-id="element-319" />
              <MenuItem icon={PackageIcon} label="Inventory Management" to="/solutions/inventory-management" data-id="element-320" />
              <MenuItem icon={FactoryIcon} label="Production" to="/solutions/manufacturing-mes" data-id="element-321" />
              <MenuItem icon={ClipboardCheckIcon} label="Quality" to="/solutions/quality" data-id="element-322" />
              <MenuItem icon={FileTextIcon} label="Sales and Quoting" to="/solutions/sales-and-quoting" data-id="element-323" />
            </div>
          </div>

          {/* By Industry */}
          <div className="col-span-3 p-6 bg-white/[0.02]" data-id="element-324">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-325">
              By Industry
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-326">
              <MenuItem icon={FactoryIcon} label="Manufacturing" to="/industries/manufacturing" data-id="element-327" />
              <MenuItem icon={CogIcon} label="Industrial Operations" to="/industries/industrial-operations" data-id="element-328" />
              <MenuItem icon={ShoppingBagIcon} label="Complex Consumer Products" to="/industries/consumer-products" data-id="element-329" />
              <MenuItem icon={FlaskConicalIcon} label="Biotech" to="/industries/biotech" data-id="element-330" />
            </div>
          </div>

          {/* By Plan */}
          <div className="col-span-3 p-6" data-id="element-331">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-332">
              By Plan
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-333">
              <MenuItem icon={CpuIcon} label="Thruline Core" to="/solutions/custom" data-id="element-334" />
              <MenuItem icon={BuildingIcon} label="Thruline Enterprise" to="/solutions/enterprise" data-id="element-335" />
              <MenuItem icon={SmartphoneIcon} label="ReceivePro" to="/solutions/receivepro" data-id="element-336" />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="grid grid-cols-12 divide-x divide-white/10 border-t border-white/10 bg-white/[0.02]" data-id="element-337">
          <div className="col-span-3" data-id="element-338"></div>
          <Link to="/solutions" className="col-span-3 px-6 py-3 flex items-center justify-between group hover:bg-white/[0.04] transition-colors" data-id="element-339">
            <span className="text-white/90 text-xs font-medium" data-id="element-340">
              View all modules
            </span>
            <ArrowRightIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" data-id="element-341" />
          </Link>
          <Link to="/solutions#industries" className="col-span-3 px-6 py-3 flex items-center justify-between group hover:bg-white/[0.04] transition-colors" data-id="element-342">
            <span className="text-white/90 text-xs font-medium" data-id="element-343">
              View all industries
            </span>
            <ArrowRightIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" data-id="element-344" />
          </Link>
          <div className="col-span-3" data-id="element-345"></div>
        </div>
      </div>
    </div>;
}